import React from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faXmark} from "@fortawesome/pro-solid-svg-icons";

import Button from "@/components/buttons/button";
import BaseDialog, {BaseDialogProps} from "@/components/dialogs/base-dialog";

interface ClosableDialogProps extends BaseDialogProps {
    showCloseButton?: boolean;
}

const ClosableDialog: React.FC<ClosableDialogProps> = ({ open, onClose, title, sizeClass, closeOnOutsideClick = true, showCloseButton = true, children }) => (
    <BaseDialog open={open} onClose={closeOnOutsideClick ? onClose : () => undefined} sizeClass={sizeClass}>
        {title && 
            <div className='flex flex-row gap-y-2 text-base font-semibold text-gray-900 pb-4'>
                {title}
                
                {showCloseButton && 
                    <Button onClick={() => onClose(true)} type='button' variant='ghost' className='ml-auto'>
                        <FontAwesomeIcon icon={faXmark} className='w-4 h-4 text-red-500'/>
                    </Button>
                }
            </div>
        }
        {children}
    </BaseDialog>
)

export default ClosableDialog;